import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { UserContext } from './UserContext';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';

const UserListCompany = () => {
    const [users, setUsers] = useState([]);
    const [companyName, setCompanyName] = useState(''); // Added state for company name
    const { user } = useContext(UserContext);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedUserId, setSelectedUserId] = useState(null);

    useEffect(() => {
        if (user && user.role === 'company') {
            fetchCompanyUsers();
        }
    }, [user]);

    const fetchCompanyUsers = async () => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/users/company-users`, {
                headers: {
                    'x-auth-token': localStorage.getItem('token')
                }
            });
            setUsers(res.data.users);
            setCompanyName(res.data.companyName); // Set the company name here
        } catch (error) {
            console.error('Error fetching company users:', error);
            // Handle error response, e.g., show an error message
        }
    };

    const handleDeleteUser = (id) => {
        setSelectedUserId(id);
        setShowDeleteModal(true);
    };

    const confirmDeleteUser = async () => {
        try {
            await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/api/users/${selectedUserId}`, {
                headers: {
                    'x-auth-token': localStorage.getItem('token')
                }
            });
            setUsers(users.filter(user => user._id !== selectedUserId));
            setShowDeleteModal(false);
        } catch (error) {
            console.error('Error deleting user:', error);
            // Handle error response, e.g., show an error message
        }
    };

    if (!user || user.role !== 'company') {
        return <div>You are not authorized to view this page.</div>;
    }

    return (
        <div id="user-list-company">
            <Container>
                <Row>
                    <Col xs={6} className="offset-lg-3">
                      <h2>{companyName ? `${companyName} User List` : 'Company User List'}</h2>
                    </Col>
                </Row>
            </Container>
            <Container>
                <Row>
                    <Col xs={6} className="offset-lg-3">
                        {users.length === 0 ? (
                            <p>No users found for your company.</p>
                        ) : (
                            users.map(user => (
                                <Card className="text-center mb-3" key={user._id}>
                                    <Card.Header> {user.firstName} {user.familyName}</Card.Header>
                                    <Card.Body>
                                        <Card.Title>{user.role}</Card.Title>
                                        <ListGroup className="list-group-flush">
                                            <ListGroup.Item>Email: {user.email}</ListGroup.Item>
                                            <ListGroup.Item>Gender: {user.gender}</ListGroup.Item>
                                            <ListGroup.Item>Birth Date: {user.birthDate}</ListGroup.Item>
                                            <ListGroup.Item>Nationality: {user.nationality}</ListGroup.Item>
                                            <ListGroup.Item>Country: {user.country}</ListGroup.Item>
                                            <ListGroup.Item>ZIP City of residence: {user.zipCity}</ListGroup.Item>
                                            <ListGroup.Item>City of residence: {user.city}</ListGroup.Item>
                                            <ListGroup.Item>Phone: {user.phone}</ListGroup.Item>
                                        </ListGroup>
                                    </Card.Body>
                                    <Card.Body>
                                        <Link to={`/user-edit/${user._id}`}>Edit</Link> {/* Edit link */}
                                        <Button variant="danger" onClick={() => handleDeleteUser(user._id)}>Delete</Button>
                                    </Card.Body>
                                </Card>
                            ))
                        )}
                    </Col>
                </Row>
            </Container>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Delete</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to delete this user?</Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={confirmDeleteUser}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default UserListCompany;

